import L from 'leaflet';
import { addQueryArgs } from '@wordpress/url';
import { invalidateSize } from '../../mixins/map';

const { __ } = wp.i18n;
//Layer
const tileLayer = L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
} );

//Search
const mapSearchNode = document.querySelector( '.realpress-map-search' );
const mapFieldsNode = document.querySelector( '.realpress_map-fields' );
const latNode = mapFieldsNode.querySelector( '#realpress_lat' );
const lonNode = mapFieldsNode.querySelector( '#realpress_lon' );
const addNameNode = mapFieldsNode.querySelector( '#realpress_name' );
const searchLoadingNode = mapSearchNode.querySelector( '.realpress-map-search-loading-wrapper' );
let map;
let lat = latNode.value;
let lon = lonNode.value;
const searchLimit = 10;
const excludedPlaceIds = [];

//Marker`
const markerCoord = [ lat, lon ];
const markerOptions = {
	draggable: true,
};
let currentMapIcon;

//Enable, disable map
const rowNodes = document.querySelectorAll( '#realpress_map_content .realpress-row' );
const enableDisableNode = rowNodes[ 0 ].querySelector( 'input[type=checkbox]' );

const realpressMap = () => {
	//Enable, disable map
	enableDisableNode.addEventListener( 'change', function() {
		handleEnableDisable( enableDisableNode );
	} );
	handleEnableDisable( enableDisableNode );
	mapInit();

	const query = {
		format: 'json', polygon: 1, addressdetails: 1, limit: searchLimit,
	};
	currentMapIcon = L.marker( markerCoord, markerOptions ).addTo( map );
	let searchValue = '';
	const searchButtonNode = mapSearchNode.querySelector( '.realpress-map-search-box-button button' );
	const searchInputNode = mapSearchNode.querySelector( '.realpress-map-search-box-input input' );
	searchInputNode.addEventListener( 'keyup', function( event ) {
		if ( event.keyCode === 13 ) {
			searchButtonNode.click();
		}
	} );
	searchButtonNode.addEventListener( 'click', function( event ) {
		event.preventDefault();
		searchValue = searchInputNode.value;
		if ( ! searchValue ) {
			return;
		}
		this.disabled = true;
		mapSearchNode.querySelector( '.realpress-map-search-result-list' ).innerHTML = '';
		mapSearchNode.querySelector( '.realpress-map-search-load-more' ).style.display = 'none';
		mapSearchNode.querySelector( '.realpress-map-search-result-header' ).style.display = 'block';
		mapSearchNode.querySelector( '.realpress-map-search-result-wrapper' ).style.display = 'block';
		displayLoading();
		const searchQuery = { ...query, q: searchValue };
		fetch( addQueryArgs( 'https://nominatim.openstreetmap.org/search', searchQuery ) )
			.then( ( result ) => result.json() )
			.then( ( parsedResult ) => {
				displaySearchResult( parsedResult, false );
				this.disabled = false;
			} )
			.catch( ( error ) => {
				console.log( error );
			} );
	} );

	mapSearchNode.querySelector( '.realpress-map-search-result-header a' ).addEventListener( 'click', function() {
		searchInputNode.value = '';
		mapSearchNode.querySelector( '.realpress-map-search-result-header' ).style.display = 'none';
		mapSearchNode.querySelector( '.realpress-map-search-result-wrapper' ).style.display = 'none';
	} );

	//Load more
	mapSearchNode.querySelector( '.realpress-map-search-result-wrapper .load-more' ).addEventListener( 'click', function( event ) {
		event.preventDefault();
		this.disabled = true;
		mapSearchNode.querySelector( '.realpress-map-search-load-more' ).style.display = 'none';
		displayLoading();
		const searchQuery = { ...query, q: searchValue, exclude_place_ids: excludedPlaceIds.toString() };
		fetch( addQueryArgs( 'https://nominatim.openstreetmap.org/search', searchQuery ) )
			.then( ( result ) => result.json() )
			.then( ( parsedResult ) => {
				displaySearchResult( parsedResult, true );
				this.disabled = false;
			} )
			.catch( ( error ) => {
				console.log( error );
			} );
	} );

	//Move icon
	handleMoveIcon();
};

const displayLoading = () => {
	searchLoadingNode.classList.add( 'realpress-loading-display' );
	setTimeout( () => {
		searchLoadingNode.classList.remove( 'realpress-loading-display' );
	}, 5000 );
};

const hideLoading = () => {
	searchLoadingNode.classList.remove( 'realpress-loading-display' );
};

const displaySearchResult = ( parsedResult, isLoadMore = false ) => {
	let html = '';
	if ( isLoadMore ) {
		html = mapSearchNode.querySelector( '.realpress-map-search-result-list' ).innerHTML;
	}
	if ( parsedResult.length ) {
		for ( let i = 0; i < parsedResult.length; i++ ) {
			html += `<li class="realpress-search-list-item"><a data-lat= "${ parsedResult[ i ].lat }" data-lon= "${ parsedResult[ i ].lon }"
						data-name ="${ parsedResult[ i ].display_name }">${ parsedResult[ i ].display_name }</a></li>`;
			excludedPlaceIds.push( parsedResult[ i ].place_id );
		}
	} else {
		html += __( 'No results were found', 'realpress' );
	}

	if ( parsedResult.length === searchLimit ) {
		mapSearchNode.querySelector( '.realpress-map-search-load-more' ).style.display = 'block';
	}

	//display result
	mapSearchNode.querySelector( '.realpress-map-search-result-list' ).innerHTML = html;
	//hide loading
	hideLoading();

	//Handle click search list item
	const searchItems = mapSearchNode.querySelectorAll( '.realpress-map-search .realpress-search-list-item' );
	for ( let i = 0; i < searchItems.length; i++ ) {
		searchItems[ i ].addEventListener( 'click', function() {
			if ( !! currentMapIcon ) {
				map.removeLayer( currentMapIcon );
			}

			const activeItem = mapSearchNode.querySelector( '.realpress-map-search-result-list li.active' );
			if ( activeItem ) {
				activeItem.classList.remove( 'active' );
			}
			this.classList.add( 'active' );

			//Set map input value
			const lat = this.querySelector( 'a' ).getAttribute( 'data-lat' );
			const lon = this.querySelector( 'a' ).getAttribute( 'data-lon' );
			const addName = this.querySelector( 'a' ).getAttribute( 'data-name' );
			setMapInputValue( lat, lon, addName );

			//Fly icon to position
			const position = new L.LatLng( lat, lon );
			currentMapIcon = new L.marker( position, {
				draggable: true,
			} ).addTo( map );
			map.flyTo( position );
			handleMoveIcon();
		} );
	}
};

const mapInit = () => {
	if ( ! lat || ! lon ) {
		lat = 20.9968774;
		lon = 105.8031701;
	}

	//Map Options
	const mapOptions = {
		layers: [ tileLayer ],
		center: [ lat, lon ],
		zoom: 13,
		minZoom: 6,
		attributionControl: false,
		scrollWheelZoom:false
	};

	map = L.map( 'realpress_address_map', mapOptions ).setView( [ lat, lon ], 13 );
	map.zoomControl.setPosition( 'topright' );

	invalidateSize( map );

	document.querySelector( '.realpress-tab-section #realpress_map_tab' ).addEventListener( 'click', function() {
		invalidateSize( map );
	} );
};

const setMapInputValue = ( lat, lon, addName ) => {
	latNode.value = lat;
	lonNode.value = lon;
	addNameNode.value = addName;
};

const handleEnableDisable = ( enableDisableNode ) => {
	if ( enableDisableNode.checked ) {
		rowNodes[ 1 ].style.opacity = 1;
	} else {
		rowNodes[ 1 ].style.opacity = 0;
	}
};

const handleMoveIcon = () => {
	currentMapIcon.on( 'dragend', function( event ) {
		const latLng = event.target.getLatLng();
		map.flyTo( latLng );
		const query = {
			lat: latLng.lat, lon: latLng.lng, format: 'json',
		};
		fetch( addQueryArgs( 'https://nominatim.openstreetmap.org/reverse', query ) )
			.then( ( result ) => result.json() )
			.then( ( parsedResult ) => {
				latNode.value = parsedResult.lat ?? '';
				lonNode.value = parsedResult.lon ?? '';
				addNameNode.value = parsedResult.display_name ?? '';
			} )
			.catch( ( error ) => {
				console.log( error );
			} );
	} );
};

export default realpressMap;
